var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinnerTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.922,
    height: 30.006,
    viewBox: "0 0 27.922 30.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f7a738;}.b{fill:#fec93e;}.c{fill:#efb635;}.d{fill:#ea9632;}.e{fill:#ff8150;}.f{fill:#fd6e2e;}.g{fill:#f2ebda;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.782)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.782 3.628)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.72,76.413h-.508a.453.453,0,1,1,0-.906h.508a.366.366,0,0,0,.164-.694l-3.6-1.8A9.966,9.966,0,0,1,17.782,64.1v-.709a1.486,1.486,0,0,1,1.484-1.484h5.367a.453.453,0,1,1,0,.906H19.266a.579.579,0,0,0-.579.579V64.1a9.06,9.06,0,0,0,5.005,8.1l3.6,1.8a1.272,1.272,0,0,1-.569,2.409Z",
    transform: "translate(-17.782 -61.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M321.778,76.413h-.508A1.272,1.272,0,0,1,320.7,74l3.6-1.8a9.06,9.06,0,0,0,5.005-8.1v-.709a.579.579,0,0,0-.578-.579h-5.367a.453.453,0,0,1,0-.906h5.367a1.486,1.486,0,0,1,1.484,1.484V64.1a9.966,9.966,0,0,1-5.505,8.912l-3.6,1.8a.366.366,0,0,0,.164.694h.508a.453.453,0,1,1,0,.906Z",
    transform: "translate(-302.286 -61.908)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M191.883,308.458v-1.97h-3.094v1.97a2.307,2.307,0,0,1-1.27,2.061l-.311.156a1.742,1.742,0,0,0-.959,1.556v2.307h8.176v-2.307a1.742,1.742,0,0,0-.959-1.556l-.311-.156A2.306,2.306,0,0,1,191.883,308.458Z",
    transform: "translate(-158.593 -288.526)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M259.128,310.675l-.311-.156a2.306,2.306,0,0,1-1.27-2.061v-1.97H256v8.05h4.088v-2.307A1.742,1.742,0,0,0,259.128,310.675Z",
    transform: "translate(-224.256 -288.526)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M138.487,39.15h0a10.587,10.587,0,0,1-6.624-9.048l-.692-9.368H145.8L145.11,30.1A10.587,10.587,0,0,1,138.487,39.15Z",
    transform: "translate(-106.744 -19.518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M260.373,20.733l-.692,9.368a16.767,16.767,0,0,1-3.718,9.048h0a10.587,10.587,0,0,0,6.624-9.048l.692-9.368Z",
    transform: "translate(-224.222 -19.518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M126.433,2.08h-16a.564.564,0,0,1-.564-.564V.564A.564.564,0,0,1,110.433,0h16A.564.564,0,0,1,127,.564v.952A.564.564,0,0,1,126.433,2.08Z",
    transform: "translate(-86.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M126.433,9.355h-16a.564.564,0,0,1-.562-.518c0,.015,0,.03,0,.046v.952a.564.564,0,0,0,.564.564h16A.564.564,0,0,0,127,9.835V8.883c0-.015,0-.031,0-.046A.563.563,0,0,1,126.433,9.355Z",
    transform: "translate(-86.689 -8.319)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M148.449,418.149h-14.28v-2.587a1.546,1.546,0,0,1,1.546-1.546H146.9a1.546,1.546,0,0,1,1.546,1.546v2.587Z",
    transform: "translate(-109.566 -389.752)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M146.9,414.016h-1.618v1.827a1.149,1.149,0,0,1-1.149,1.149h-9.967v1.157h14.28v-2.587A1.546,1.546,0,0,0,146.9,414.016Z",
    transform: "translate(-109.566 -389.752)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M127.2,480.88H110.471a.176.176,0,0,1-.176-.176v-1.585a.176.176,0,0,1,.176-.176H127.2a.176.176,0,0,1,.176.176V480.7A.176.176,0,0,1,127.2,480.88Z",
    transform: "translate(-87.091 -450.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M214.207,312.6h-3.745a.846.846,0,0,1-.846-.846v-.273a.846.846,0,0,1,.846-.846h3.745a.846.846,0,0,1,.846.846v.273A.846.846,0,0,1,214.207,312.6Z",
    transform: "translate(-180.591 -292.426)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M214.207,319.5h-3.745a.846.846,0,0,1-.767-.491.841.841,0,0,0-.079.355v.273a.846.846,0,0,0,.846.846h3.745a.846.846,0,0,0,.846-.846v-.273a.841.841,0,0,0-.079-.355A.846.846,0,0,1,214.207,319.5Z",
    transform: "translate(-180.591 -300.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M185.33,72.5l1.048,2.895,3.077.1a.148.148,0,0,1,.086.265l-2.429,1.892.853,2.958a.148.148,0,0,1-.225.164l-2.55-1.726-2.55,1.726a.148.148,0,0,1-.225-.164l.853-2.958-2.429-1.892a.148.148,0,0,1,.086-.265L184,75.4l1.048-2.895A.148.148,0,0,1,185.33,72.5Z",
    transform: "translate(-153.448 -68.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M127.2,478.943H124.21v.626a.67.67,0,0,1-.67.67H110.471a.176.176,0,0,1-.176-.176v.641a.176.176,0,0,0,.176.176H127.2a.176.176,0,0,0,.176-.176v-1.585A.176.176,0,0,0,127.2,478.943Z",
    transform: "translate(-87.091 -450.874)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerTrophy);
export default __webpack_public_path__ + "static/media/winner_trophy.e86a4c28425e2caeb6a3b3183aacd044.svg";
export { ForwardRef as ReactComponent };